import script from "./PublicSubHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicSubHeader.vue?vue&type=script&setup=true&lang=js"

import "./PublicSubHeader.vue?vue&type=style&index=0&id=282a4af5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282a4af5"]])

export default __exports__